



























import { Component, Vue } from "vue-property-decorator";
import GameConfig from "@/game/game-config";
import { Item, ItemState, ItemPurchase } from "@/game/Models/item";
import { ShopItemViewModel } from "@/game/ViewModels/shop-item";

@Component
export default class Items extends Vue {
  get items(): ShopItemViewModel[] {
    const itemState: ItemState[] = this.$store.state.items;
    const shopItems = itemState.map(is => new ShopItemViewModel(GameConfig.GetItem(is.itemId), is));
    return shopItems;
  }

  purchase(itemId: string, amount: number) {
    this.$store.commit("purchase", {
      itemId: itemId,
      amount: amount,
    } as ItemPurchase);
  }

  canBuy(itemId: string): boolean {
    const itemState = this.$store.state.items.filter((i: ItemState) => i.itemId === itemId)[0];
    const item = GameConfig.GetItem(itemId);
    const declaraties = this.$store.state.declaraties;
    return item.GetPrice(itemState.amount) <= declaraties;
  }
}
